import { h } from 'preact';
import Image from 'utils/image';
import { trackPDPSetIncludeClick } from 'utils/tracking';
import updateURL from '../utils/update-url';

const BundleChild = ({ product }) => {
  const productImage = product.media.length ? product.media[0].image : null;
  const productOption =
    product.options[0]?.values[0] !== 'Default Title'
      ? product.options[0]?.values[0]
      : '';

  const handleBundleChildClick = (e) => {
    e.preventDefault();
    const text = `${product.title} - ${product.variants[0].sku}`;
    trackPDPSetIncludeClick(text);
    window.location = updateURL(
      `${Shopify.routes.root}products/${product.handle}`,
    );
  };

  return (
    <a
      href={`${Shopify.routes.root}products/${product.handle}`}
      className="flex justify-start gap-3 lg:gap-6 bg-grey-6 pt-4 pb-[18px] lg:px-5 border border-grey-6
       border-b-grey-4 focus:border-blue last-of-type:border-b-grey-6"
      onClick={(e) => handleBundleChildClick(e)}
    >
      <div className="flex items-center basis-[60px] max-w-[60px] lg:basis-[100px] lg:max-w-[100px]">
        <Image
          {...productImage}
          srcWidths={{ sm: 200, md: 400 }}
          classes="w-[60px] h-[60px] lg:w-[100px] lg:h-[100px]"
        />
      </div>
      <div className="flex-1 flex flex-col justify-center">
        <span className="text-headline-tag text-black hover:underline">
          {product?.title}
        </span>
        <span className="text-product-tag text-black hover:underline">
          {product?.subtitle}
        </span>
        <span className="text-link-light text-grey-7">{productOption}</span>
      </div>
    </a>
  );
};

export default BundleChild;
